const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787'
const KAIROS_KOSMOS_API_URL = import.meta.env.VITE_KAIROS_KOSMOS_API_URL || ''

export const API_ENDPOINTS = {
  AUTH_LOGIN: `${API_URL}/api/v1/auth/login`,
  AUTH_LOGOUT: `${API_URL}/api/v1/auth/logout`,
  MEMORIES: `${API_URL}/api/v1/memories`,
  HEALTH: `${API_URL}/api/v1/health`,
  VERSION: `${API_URL}/api/v1/version`,
  PEOPLE: KAIROS_KOSMOS_API_URL ? `${KAIROS_KOSMOS_API_URL}/api/people` : '',
} as const

export function getMemoryEndpoint(id: string): string {
  return `${API_URL}/api/v1/memories/${id}`
}

export { API_URL, KAIROS_KOSMOS_API_URL }